export const USERROUTES = [
  { url: 'home', txt: 'Home' },
  { url: 'about', txt: 'About' },
  { url: 'shop', txt: 'Shop Parts' },
  { url: 'sell', txt: 'Sell' },
  { url: 'blog', txt: 'Blog' },
  { url: 'contact', txt: 'Contact' }
]
